<template>
	<el-row>
		<el-row style="background-color: #f9f9f9;">
			<el-col :span="14" style="display: flex;align-items: center;">
				<!-- 图片 -->
				<div>
					<el-image :src="info.themePic" style="width: 200px;height: 120px;" />
				</div>
				<div
					style="color: #99a0b2;width: 40%; height: 120px;margin: 15px 20px;display: flex;flex-direction: column;justify-content: space-around;align-items: auto; ">
					<!-- 标题 -->
					<div style="color: #66676a;font-weight: bold">{{ info.courseName }}(共{{ info.num }}节课)</span></div>
					<!-- 副标题 -->
					<span>{{ info.courseSubTitle }}</span>
					<div style="display: flex;">
						<!-- 方向 -->
						<div style="height: 25px;background-color: #e4e4e4;text-align: center;line-height: 25px;">
							<span style="color: #66676a">{{ info.directionName }}</span>
						</div>
						<!-- 类别 -->
						<div
							style="height: 25px;background-color: #e4e4e4;text-align: center;line-height: 25px;margin-left: 10px;">
							<span style="color: #66676a">{{ info.courseCategoryName.join('>') }}</span>
						</div>
					</div>
					<div>
						<!-- 是否免费以及价钱 -->
						<span>{{ info.free == 0 ? "免费" : info.free == 1 ? '付费' : '' }}:</span><span
							style="color: #fe181f;font-size: 15px;">￥{{
								info.coursePrice ? info.coursePrice : 0
							}}元</span>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 152px;display: flex;flex-direction: column;">
				<div style="display: flex;align-items: center;height: 50px;">
					<div style="width: 200px;">
						<span>{{ info.playNum }}播放</span>
					</div>
					<div style="width: 230px;">
						<span>发布者:{{ info.publisherName ? info.publisherName : "后台" }}</span>
					</div>
					<div style="width: 200px;">
						<span>发布时间:{{ info.created }}</span>
					</div>
				</div>
				<div
					style="width: 90%;height: 50px;color: #666666;display: flex;align-items: center;justify-content: flex-end;">
					<span>浏览/点赞/分享/购买/观看(人次)</span>
					<span style="padding: 0 10px;">{{ info.lookNum }}/{{ info.praiseNum }}/{{ info.shareNum }}/{{
						info.buyNum
					}}/{{ info.playNum }}</span>
				</div>
				<div style="width: 90%;height: 50px;display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="infor" size="mini" style="color: #0081FF;" @click="xiugai()">修改信息</el-button>
					<el-button type="infor" size="mini" style="color: #0081FF;" @click="sxjia()">
						{{ info.status == 1 ? "上架" : "下架" }}
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6" style="height: 50px;">
				{{ this.getnowdata() }}&nbsp;当日{{ jiedian }}:&nbsp;{{ numDay }}次
			</el-col>
			<el-col :span="15" style="height: 50px;">
				累计{{ jiedian }}:&nbsp;{{ countNum }}&nbsp;次
			</el-col>
			<el-col :span="1" style="height: 50px;">
				<el-button size="mini" type="primary" @click="daochu()">导出近3000条数据</el-button>
			</el-col>
		</el-row>
		<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
			default-active="lookNum" style="height: 100px;">
			<el-menu-item index="lookNum">浏览数据</el-menu-item>
			<el-menu-item index="praiseNum">点赞数据</el-menu-item>
			<el-menu-item index="shareNum">分享数据</el-menu-item>
			<el-menu-item index="buyNum">购买人数</el-menu-item>
			<el-menu-item index="playNum">观看人数</el-menu-item>
		</el-menu>
		<div v-if="activeIndex == 'lookNum'">
			<el-table :data="tableData">
				<el-table-column label="序号" prop="id">
				</el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="浏览时间" prop="time"></el-table-column>
			</el-table>
		</div>
		<div v-if="activeIndex == 'praiseNum'">
			<el-table :data="tableData2">
				<el-table-column label="序号" prop="id"></el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="点赞时间" prop="time"></el-table-column>
				<el-table-column label="取关/点赞" prop="status">
					<template slot-scope="scope">
						{{ scope.row.status == 0 ? "取关" : scope.row.status == 1 ? '点赞' : '' }}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="activeIndex == 'shareNum'">
			<el-table :data="tableData3">
				<el-table-column label="序号" prop="id"></el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="分享时间" prop="time"></el-table-column>
			</el-table>
		</div>
		<div v-if="activeIndex == 'buyNum'">
			<el-table :data="tableData4">
				<el-table-column label="序号" prop="id"></el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="购买时间" prop="time"></el-table-column>
			</el-table>
		</div>
		<div v-if="activeIndex == 'playNum'">
			<el-table :data="tableData5">
				<el-table-column label="序号" prop="id"></el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="观看时间" prop="time"></el-table-column>
				<el-table-column label="观看小课标题" prop="lessonName"></el-table-column>
			</el-table>
		</div>
		<div style="margin: 40px 30%;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30, 50, 100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="60%" center @change="gb()">
			<el-form label-position="right" label-width="250px" :rules="xgInfoRules" ref="xgInfo" :model="xgInfo">
				<div v-if="isShow">
					<el-form-item label="方向:" prop="direction">
						<el-select size="mini" class="margin-left-10" v-model="xgInfo.direction">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分类:" prop="category">
						<el-cascader size="mini" v-model="xgInfo.category" :options="options2" :props="cateListProps"
							clearable style="width: 300px;" />
					</el-form-item>
					<el-form-item label="标题:" prop="courseName">
						<el-input placeholder="50字" maxlength="50" size="mini" style="width: 400px"
							v-model="xgInfo.courseName" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="副标题:">
						<el-input placeholder="50字" maxlength="50" size="mini" style="width: 400px"
							v-model="xgInfo.courseSubTitle" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="课件封面:" prop="themePic">
						<el-radio-group v-model="radioValue" @input="chooseRadio()">
							<el-radio label="0">本地上传</el-radio>
							<el-radio label="1">图片库上传</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-upload :class="{ hide: hideUpload }" :action="uploadUrl" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="xgInfo.themePic"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed" append-to-body>
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>最多上传1张,建议比例16:9</span>
					</el-form-item>

					<el-form-item label="付费类型:" prop="free" @change="xzLx()">
						<el-radio-group v-model="xgInfo.free">
							<el-radio :label="1">付费</el-radio>
							<el-radio :label="0">免费</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="付费群体:">
						<el-checkbox-group v-model="xgInfo.payGroup">
							<!-- <el-checkbox label="70">潜在</el-checkbox> -->
							<el-checkbox :label="70">新客</el-checkbox>
							<el-checkbox :label="60">粉丝</el-checkbox>
							<el-checkbox :label="50">vip</el-checkbox>
							<el-checkbox :label="45">svip</el-checkbox>
							<el-checkbox :label="40">vp</el-checkbox>
							<el-checkbox :label="30">vk</el-checkbox>
							<el-checkbox :label="20">2s</el-checkbox>
							<el-checkbox :label="10">4s</el-checkbox>
						</el-checkbox-group>
						<div style="color: #cca771">提示：未选择的则默认免费使用！</div>
					</el-form-item>
					<el-form-item label="课件价格:" prop="coursePrice" v-if="xgInfo.free == 1">
						<el-input size="mini" style="width: 100px" type="number" min="0" v-model="xgInfo.coursePrice">
						</el-input>元
					</el-form-item>
				</div>
				<el-form-item label="课件介绍:" prop="courseIntroduce" v-if="!isShow" label-width="100px">
					<wangeditor v-model="xgInfo.courseIntroduce" style="width: 900px;margin-right: 800px;" />
				</el-form-item>
				<el-form-item label-width="500px">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="queren()">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer title="图片选择" :visible.sync="drawer2" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
import httpClient from '../../../util/request.js'
import SelectPicture from '../../../components/SelectPicture/index.vue'

export default {
	components: {
		SelectPicture
	},
	data() {
		return {
			drawer2: false,
			radioValue: '0',
			uploadUrl: httpClient.imgUrl,
			activeIndex: 'lookNum',
			jiedian: "浏览次数",
			tableData: [],
			tableData2: [],
			tableData3: [],
			tableData4: [],
			tableData5: [],
			hideUpload: false,
			cateListProps: {
				value: "dicId", //匹配响应数据中的id
				label: "dicDesc", //匹配响应数据中的name
				children: "sonDicList", //匹配响应数据中的children
			},
			total: 0,
			pageSize: 30,
			pageNum: 1,
			numDay: 0,
			countNum: '',
			options2: [],
			options: [],
			centerDialogVisible: false, //弹出框状态
			title: '',
			isShow: true,
			dialogImageUrl: '',
			dialogDisplay: false,
			info: {
				status: '',
				courseName: "",
				themePic: '', //图片
				directionName: '', //方向名
				courseCategoryName: [], //类别名
				courseSubTitle: '', //副标题
				created: "", //创建时间
				free: '', //付费类型id
				coursePrice: "", //价格
				lookNum: '', //浏览数
				publisherName: '', //平台
				num: '', //课的节数
				praiseNum: "", //点赞数
				shareNum: '', // * 分享数
				buyNum: "", // * 购买数
				playNum: '', // * 播放量 
			},
			xgInfo: {
				courseId: "", //id
				direction: "", //方向
				category: [], //类别
				courseName: "", //标题
				courseSubTitle: '', //副标题
				coursePrice: '', //10000
				themePic: [], //课程主图更新
				free: '', //免费
				courseIntroduce: '', //课程介绍
				status: '', //状态
				payGroup: []
			},
			xgInfoRules: {
				direction: [{
					required: true,
					trigger: "blur",
					message: "请选择方向",
				},],
				category: [{
					required: true,
					trigger: "blur",
					message: "请选择分类",
				},],
				courseName: [{
					required: true,
					trigger: "blur",
					message: "请输入标题",
				},],
				themePic: [{
					required: true,
					trigger: "blur",
					message: "请上传课件封面",
				},],
				free: [{
					required: true,
					trigger: "blur",
					message: "请选择付费类型",
				},],
				coursePrice: [{
					required: true,
					trigger: "blur",
					message: "请输入课件价格",
					pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
				},],
				courseIntroduce: [{
					required: true,
					trigger: "blur",
					message: "请输入课程介绍",
				},],
			},
		}
	},
	methods: {
		chooseRadio() {
			if (this.radioValue == 1) {
				this.drawer2 = true
			}
		},
		getImg(e) {
			console.log(e)
			this.xgInfo.themePic = [];
			[e].forEach(item => {
				this.xgInfo.themePic.push({
					url: item
				})
			})
			this.drawer2 = false
		},
		handleSizeChange(val) {
			this.pageNum = 1;
			this.pageSize = val;
			this.handleSelect()
		},
		//页数
		handleCurrentChange(val) {
			this.pageNum = val;
			this.handleSelect()()
		},
		daochu() {
			console.log(this.activeIndex);
			this.$http.post(
				'/api/course/clrCount/excelCount?courseId=' + this.$route.query.courseId + '&courseName=' + this
					.info.courseName + '&type=' + this.activeIndex, {}, {
				responseType: 'blob'
			}).then((res) => {
				console.log(res);
				this.$message({
					type: 'info',
					message: '正在导出表格'
				});
				const link = document.createElement('a');
				let blob = new Blob([res.data], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				//设置连接
				link.href = URL.createObjectURL(blob);
				link.download = '数据列表';
				document.body.appendChild(link);
				//模拟点击事件
				link.click();
				window.URL.revokeObjectURL(link.href);
				link.remove();
			})
		},
		handleSelect(key, keyPath) {
			this.activeIndex = key
			this.$http.get(
				`/api/course/clrCount/getCountDetail?courseId=${this.$route.query.courseId}&type=${this.activeIndex}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {}
			).then(res => {
				console.log(res.data.data);
				if (this.activeIndex == "lookNum") {
					this.jiedian = "浏览次数"
					this.numDay = res.data.data.numDay
					this.countNum = res.data.data.countNum
					this.total = res.data.data.detailList.total
					this.tableData = res.data.data.detailList.list
				}
				if (this.activeIndex == "praiseNum") {
					this.jiedian = "点赞次数"
					this.numDay = res.data.data.numDay
					this.countNum = res.data.data.countNum
					this.total = res.data.data.detailList.total
					this.tableData2 = res.data.data.detailList.list
				}
				if (this.activeIndex == "shareNum") {
					this.jiedian = "分享次数"
					this.numDay = res.data.data.numDay
					this.countNum = res.data.data.countNum
					this.total = res.data.data.detailList.total
					this.tableData3 = res.data.data.detailList.list
				}
				if (this.activeIndex == "buyNum") {
					this.jiedian = "购买人数"
					this.numDay = res.data.data.numDay
					this.countNum = res.data.data.countNum
					this.total = res.data.data.detailList.total
					this.tableData4 = res.data.data.detailList.list
				}
				if (this.activeIndex == "playNum") {
					this.jiedian = "观看人数"
					this.numDay = res.data.data.numDay
					this.countNum = res.data.data.countNum
					this.total = res.data.data.detailList.total
					this.tableData5 = res.data.data.detailList.list
				}
			})
		},
		xzLx() {
			if (this.xgInfo.free == 0) {
				this.xgInfo.coursePrice == 0;
			}
		},
		//上传成功
		getPictrueURL(response, file, fileList) {
			this.xgInfo.themePic.push({
				url: response.data,
			});
			this.hideUpload = fileList.length >= 1;
		},
		// 款式主图预览
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogDisplay = true;
		},
		// 款式主图上传框删除一个图片
		handleRemove(file, fileList) {
			this.xgInfo.themePic = [];
			this.hideUpload = false;
		},
		// 款式主图预览dialog关闭时的回调
		imagePrevClosed() {
			this.dialogImageUrl = "";
		},
		//上下架
		sxjia() {
			console.log(this.data.status);
			if (this.data.status == 0) {
				this.xgInfo.status = 1
			} else if (this.data.status == 1) {
				this.xgInfo.status = 0
			}
			this.$confirm('此操作将改变上下架状态, 是否继续?', '上下架提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post(`/api/course/clrCourse/updateCourse`, {
					courseId: this.data.courseId, //id
					status: this.xgInfo.status
				}).then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.success(res.data.data)
						this.centerDialogVisible = false
						this.getInfo()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		queren() {
			this.$refs.xgInfo.validate((valid) => {
				if (valid) {
					//修改信息
					if (this.title == "修改信息") {
						let category = "";
						let payGroup = "";
						if (this.xgInfo.payGroup.length > 0) {
							payGroup = this.xgInfo.payGroup.join(",");
						}
						if (this.xgInfo.category.length > 0) {
							category = this.xgInfo.category[1];
						} else {
							category = this.xgInfo.category;
						}
						if (this.xgInfo.free == 0) {
							this.xgInfo.coursePrice = 0
						}
						this.$http
							.post(`/api/course/clrCourse/updateCourse`, {
								courseId: this.xgInfo.courseId, //id
								direction: this.xgInfo.direction, //方向
								category: category, //类别
								courseName: this.xgInfo.courseName, //标题
								courseSubTitle: this.xgInfo.courseSubTitle, //副标题
								coursePrice: this.xgInfo.coursePrice, //10000
								themePic: this.xgInfo.themePic[0].url, //课程主图更新
								free: this.xgInfo.free, //免费
								payGroup: payGroup,
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data);
									this.centerDialogVisible = false;
									this.getInfo();
								} else {
									this.$message.error(res.data.msg);
								}
							});
					} else if (this.title == "修改课程介绍") {
						this.$http
							.post(`/api/course/clrCourse/updateCourse`, {
								courseId: this.data.courseId, //id
								courseIntroduce: this.xgInfo.courseIntroduce,
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data);
									this.centerDialogVisible = false;
									this.getInfo();
								} else {
									this.$message.error(res.data.msg);
								}
							});
					}
				}
			});
		},
		//修改信息
		xiugai() {
			this.centerDialogVisible = true
			this.isShow = true
			this.title = "修改信息"
			this.xgInfo.courseId = this.data.courseId
			this.xgInfo.direction = this.data.direction
			this.xgInfo.category = this.data.category
			this.xgInfo.courseName = this.data.courseName
			this.xgInfo.courseSubTitle = this.data.courseSubTitle
			this.xgInfo.themePic = []
			this.xgInfo.themePic.push({
				url: this.data.themePic
			})
			if (this.xgInfo.themePic[0].url) {
				this.hideUpload = true
			}
			this.xgInfo.free = this.data.free
			this.xgInfo.coursePrice = this.data.coursePrice
			let arr = [];
			console.log(this.data);
			if (this.data.payGroup) {
				this.data.payGroup.split(",").forEach((i) => {
					arr.push(i - 0);
				});
				console.log(arr);
				this.xgInfo.payGroup = arr;
			}
		},
		//方向
		getInfo2() {
			this.$http
				.get(
					`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=405`, {}
				)
				.then((res) => {
					// console.log(res.data.data, "方向");
					if (res.data.data.length > 0) {
						res.data.data.forEach((i) => {
							this.options.push({
								label: i.dicDesc,
								value: i.dicId,
							});
						});
					}
				});
		},
		//类别
		getInfo3() {
			this.$http
				.get(
					`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}
				)
				.then((res) => {
					// console.log(res.data.data, "类别");
					if (res.data.data.length > 0) {
						res.data.data.forEach((i) => {
							console.log(i);
							if (i.sonDicList == null) {
								i.sonDicList = []
							}
						});
						this.options2 = res.data.data;
					}
				});
		},
		getInfo() {
			this.$http.post(`/api/course/clrCourse/selectCourseById?courseId=${this.$route.query.courseId}`, {}).then(
				res => {
					console.log(res.data.data);
					if (res.data.data) {
						this.data = res.data.data
						// this.info.id = res.data.
						this.info.courseName = this.data.courseName
						this.info.status = this.data.status
						if (this.data.themePic) {
							this.info.themePic = this.data.themePic
						}
						this.info.directionName = this.data.directionName
						this.info.courseSubTitle = this.data.courseSubTitle
						this.info.created = this.data.created
						this.info.free = this.data.free
						this.info.num = this.data.num
						this.info.coursePrice = this.data.coursePrice
						this.info.lookNum = this.data.lookNum //浏览数
						this.info.publisherName = this.data.publisherName //平台
						this.info.praiseNum = this.data.praiseNum //点赞数
						this.info.shareNum = this.data.shareNum // * 分享数
						this.info.buyNum = this.data.buyNum // * 购买数
						this.info.playNum = this.data.playNum // * 播放量 
						this.info.courseCategoryName = this.data.courseCategoryName.split('---')
					}
				})
		},
		getnowdata() {
			var date = new Date();
			var sign1 = "-";
			var sign2 = ":";
			var year = date.getFullYear(); // 年
			var month = date.getMonth() + 1; // 月
			var day = date.getDate(); // 日
			var hour = date.getHours(); // 时
			var minutes = date.getMinutes(); // 分
			var seconds = date.getSeconds(); //秒
			// 给一位数数据前面加 “0”
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (day >= 0 && day <= 9) {
				day = "0" + day;
			}
			var currentdate = year + sign1 + month + sign1 + day
			return currentdate;
		},
	},
	created() {
		this.getnowdata()
		this.getInfo()
		this.getInfo2()
		this.getInfo3()
		this.$http.get(
			`/api/course/clrCount/getCountDetail?courseId=${this.$route.query.courseId}&type=lookNum&pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {}
		).then(
			res => {
				console.log(res.data.data);
				this.jiedian = "浏览次数"
				this.countNum = res.data.data.countNum
				this.numDay = res.data.data.numDay
				this.total = res.data.data.detailList.total
				this.tableData = res.data.data.detailList.list
			})
	}
}
</script>

<style scoped>

</style>
